import { map } from 'lodash';
import { createAction } from 'redux-actions';
import { CALL_API } from '../constants';

const toAllergy = ({
  comments,
  actions,
  lastReactionDate,
  description,
  id,
  reaction,
}) => ({
  comments,
  actions,
  date: lastReactionDate,
  type: description,
  id,
  reaction,
});

const AllergiesService = {
  getByPatientId: createAction(CALL_API, patientId => ({
    method: 'GET',
    path: `/allergies/patient/${patientId}`,
    handleResponse: allergies => map(allergies, toAllergy),
    handleError: () =>
      Promise.reject(
        'We were unable to load your allergy information. Please refresh the page to try again.',
      ),
  })),

  create: createAction(CALL_API, allergies => ({
    body: allergies,
    method: 'POST',
    path: '/allergies/bulk',
    handleError: () =>
      Promise.reject('Something went wrong. Please try again.'),
  })),
};

export default AllergiesService;



// WEBPACK FOOTER //
// ./src/lib/dataLayer/allergies/AllergiesService.js